import { EntityTypes } from 'constants/entities';
import { selectActionPreview } from 'core/selectors/product/action/actionPreviewImage';
import { selectSceneRotation } from 'core/selectors/product/scene/sceneRotation';
import { useAppSelector } from 'core/store/hooks';
import { PropsWithChildren, memo } from 'react';
import useImage from 'use-image';

export const ActionPreviewImage = memo(
  ({ id, className, children }: PropsWithChildren<{ id: number; className: string }>) => {
     //@ts-ignore
    const preview = useAppSelector(state => selectActionPreview(state, id));
    const sceneId = useAppSelector(state => state.entity.present[EntityTypes.ACTION][id]?.sceneId);
     //@ts-ignore
    const rotation = useAppSelector(state => selectSceneRotation(state, sceneId));
    const [image, status] = useImage(preview);

    if (image)
      return (
        <div className={className}>
          <div
            style={{
              height: '100%',
              width: '100%',
              backgroundImage: `url(${image.src})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              transform: `rotate(${rotation}deg)`,
              overflow: 'hidden',
              backgroundRepeat: 'no-repeat',
              backgroundColor: 'transparent',
            }}
          >
            {children}
          </div>
        </div>
      );
  },
);
